import Vue from 'vue'
import BFormGroup from 'b-form-group'
import Vuemerang from 'vuemerang'
import 'vuemerang/dist/vuemerang.css'

Vue.use(BFormGroup)
Vue.use(Vuemerang, {
  theme: {
    colors: {
      primary: '#ff7800',
      secondary: '#1a1b28',
      success: 'rgb(23, 201, 100)',
      danger: 'rgb(242, 19, 93)',
      warning: 'rgb(255, 130, 0)',
      dark: 'rgb(36, 33, 69)',
      gray: '#afbbc6'
    }
  }
})
